import { WorkItemTypeEnum } from "../../store/services/timelineApiRTK";

export interface Attendee {
  email: string;
  name?: string;
}

export enum MeetingPlatform {
  TEAMS = "teams",
  ZOOM = "zoom",
  GOOGLE_MEET = "google_meet",
  IN_PERSON = "in_person",
}

export interface MeetingFormData {
  subject: string;
  startDateTime: Date;
  endDateTime: Date;
  description: string;
  platform: MeetingPlatform;
  location?: string; // Location for in-person meetings
  attendees: Attendee[];
  sendInvitations: boolean;
  createWorkItem: boolean;
  workItemType: WorkItemTypeEnum;
}

// Predefined meeting durations in minutes
export enum MeetingDuration {
  FIFTEEN_MIN = 15,
  THIRTY_MIN = 30,
  ONE_HOUR = 60,
  NINETY_MIN = 90,
  TWO_HOURS = 120,
  CUSTOM = 0,
}

export const getDefaultMeetingFormData = (): MeetingFormData => {
  const now = new Date();
  now.setSeconds(0);
  now.setMilliseconds(0);

  // Nästa kvart (t.ex. 10:17 ⇒ 10:30)
  const nextQuarter = new Date(now);
  const minutes = nextQuarter.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;
  
  if (roundedMinutes === 60) {
    nextQuarter.setHours(nextQuarter.getHours() + 1);
    nextQuarter.setMinutes(0);
  } else {
    nextQuarter.setMinutes(roundedMinutes);
  }

  const start = new Date(nextQuarter);
  const end = new Date(start);
  end.setMinutes(start.getMinutes() + 30);

  return {
    subject: "",
    startDateTime: start,
    endDateTime: end,
    description: "",
    platform: MeetingPlatform.TEAMS,
    location: "",
    attendees: [],
    sendInvitations: true,
    createWorkItem: true,
    workItemType: WorkItemTypeEnum.DigitalMeeting,
  };
};